__turbopack_context__.v({
  "black": "Button-module__xaXzvq__black",
  "disabled": "Button-module__xaXzvq__disabled",
  "gradientEpic": "Button-module__xaXzvq__gradientEpic",
  "gray": "Button-module__xaXzvq__gray",
  "large": "Button-module__xaXzvq__large",
  "larger": "Button-module__xaXzvq__larger",
  "medium": "Button-module__xaXzvq__medium",
  "orange": "Button-module__xaXzvq__orange",
  "root": "Button-module__xaXzvq__root",
  "small": "Button-module__xaXzvq__small",
  "transparent": "Button-module__xaXzvq__transparent",
  "twitterBlue": "Button-module__xaXzvq__twitterBlue",
  "white": "Button-module__xaXzvq__white",
  "xlarge": "Button-module__xaXzvq__xlarge",
});
